var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-modal-ex",
    {
      attrs: {
        active: _vm.isActive,
        "animation-in": _vm.animationIn,
        "animation-out": _vm.animationOut,
        "animation-duration": _vm.animationDuration,
        "can-cancel": false,
        "has-modal-card": "",
      },
      on: {
        "update:active": function ($event) {
          _vm.isActive = $event
        },
      },
    },
    [
      _c("div", { staticClass: "model-content" }, [
        _c("div", { staticClass: "modal-card" }, [
          _c("header", { staticClass: "modal-card-head" }, [
            _c(
              "p",
              { staticClass: "modal-card-title" },
              [_vm._t("text-title")],
              2
            ),
          ]),
          _c("section", { staticClass: "modal-card-body" }, [
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "field" }, [
                _c("label", { staticClass: "label mb-4" }, [
                  _vm._v("Please Select Labour Item Type"),
                ]),
                _c(
                  "div",
                  { staticClass: "control is-flex" },
                  _vm._l(_vm.labourItems, function (item, index) {
                    return _c("div", { key: index }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "pretty p-icon p-curve p-smooth p-bigger mr-6",
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedLabourItemTypes,
                                expression: "selectedLabourItemTypes",
                              },
                            ],
                            attrs: { type: "checkbox" },
                            domProps: {
                              value: item.value,
                              checked: Array.isArray(
                                _vm.selectedLabourItemTypes
                              )
                                ? _vm._i(
                                    _vm.selectedLabourItemTypes,
                                    item.value
                                  ) > -1
                                : _vm.selectedLabourItemTypes,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.selectedLabourItemTypes,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = item.value,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.selectedLabourItemTypes = $$a.concat(
                                        [$$v]
                                      ))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.selectedLabourItemTypes = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.selectedLabourItemTypes = $$c
                                }
                              },
                            },
                          }),
                          _c("div", { staticClass: "state p-primary" }, [
                            _c("i", { staticClass: "icon mdi mdi-check" }),
                            _c("label", [
                              _vm._v(" " + _vm._s(item.name) + " "),
                            ]),
                          ]),
                        ]
                      ),
                    ])
                  }),
                  0
                ),
              ]),
            ]),
          ]),
          _c(
            "footer",
            {
              staticClass: "modal-card-foot",
              style: `justify-content: flex-${_vm.buttonLocation}`,
            },
            [
              _c(
                "button",
                { staticClass: "button is-primary", on: { click: _vm.add } },
                [_vm._v("Add Labour Item")]
              ),
              _c(
                "button",
                { staticClass: "button", on: { click: _vm.close } },
                [_vm._v("Close")]
              ),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }